import { graphql } from '../../graphql';

export const cityAndLocationsQuery = graphql(`
  query CityAndLocations(
    $cityId: ID!
    $scope: LocationScopeEnum!
    $limit: Int!
  ) {
    city(id: $cityId) {
      id
      name
      slug
      latitude
      longitude
    }
    locations(filter: { scope: $scope, cityId: $cityId }, limit: $limit) {
      id
      name
      fullName
      locationGroupId
      slug
    }
  }
`);
